import {combineEpics} from 'redux-observable';
import filtersEpic from './filtersEpic';
import customersEpic from './customersEpic';

export default combineEpics(customersEpic, filtersEpic);
